/**
 * Centralized UserType definitions.
 * 
 * Mirror of backend/src/constants/userTypes.ts
 * 
 * BRAND is the primary type for campaign creators (brands/companies).
 * AGENCY shares the same dashboard and features as BRAND.
 * 'host' is kept for backward compatibility with existing DB records.
 */

export const USER_TYPES = {
  BRAND: 'brand',
  INFLUENCER: 'influencer',
  AGENCY: 'agency',
  /** @deprecated Use BRAND instead. Kept for backward compatibility with existing DB records. */
  HOST: 'host',
} as const;

export type UserType = (typeof USER_TYPES)[keyof typeof USER_TYPES];

/** All valid userType values (includes legacy 'host') */
export const VALID_USER_TYPES: UserType[] = Object.values(USER_TYPES);

/** UserTypes that use the Brand dashboard and host profile table */
export const HOST_LIKE_TYPES: UserType[] = [USER_TYPES.BRAND, USER_TYPES.AGENCY, USER_TYPES.HOST];

/** Check if a value is a valid userType */
export function isValidUserType(value: unknown): value is UserType {
  return typeof value === 'string' && VALID_USER_TYPES.includes(value as UserType);
}

/** Check if a userType should be treated as a brand/host (same dashboard/features) */
export function isHostLike(userType: string): boolean {
  return HOST_LIKE_TYPES.includes(userType as UserType);
}
